<template>
    <div>
        <NavBarAdmin></NavBarAdmin>
        <h4 class="mt-4 mb-3">Lista de tramos completos</h4>
        <ListCompleteSections @sendCompleteSectionId="getCompSectionId"></ListCompleteSections>
        <EditCompleteSection v-show="showEditCompSection" :getCompSectionIdToEdit="completeSectionId"
            @hideEditCompSection="hideCompSection">
        </EditCompleteSection>
        <FooterAdmin></FooterAdmin>
    </div>
</template>
<script>
import NavBarAdmin from "@/components/Admin/NavbarAdminComponent.vue";
import FooterAdmin from "@/components/Admin/FooterAdminComponent.vue";
import ListCompleteSections from "@/components/Admin/CompleteSections/ListCompleteSectionsComponent.vue";
import EditCompleteSection from "@/components/Admin/CompleteSections/EditCompleteSectionsComponent.vue";
export default {
    data() {
        return {
            showEditCompSection: false,
            completeSectionId: null,
        };
    },
    components: {
        NavBarAdmin,
        FooterAdmin,
        ListCompleteSections,
        EditCompleteSection,
    },
    methods: {
        getCompSectionId(data) {
            this.completeSectionId = data;
            //console.log(this.priceId);
            this.showEditCompSection = true;
        },
        hideCompSection(data) {
            this.showEditCompSection = data;
            this.completeSectionId = null;
        },
    },
};
</script>